import { render, staticRenderFns } from "./SubscriptionsTab.vue?vue&type=template&id=8bf36046&scoped=true&"
import script from "./SubscriptionsTab.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsTab.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionsTab.vue?vue&type=style&index=0&id=8bf36046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf36046",
  null
  
)

export default component.exports